const staticFileBasePath = '/assets/static';
const s3Url = import.meta.env.VITE_STORAGE_URL;

const appConfig = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_STRENGTH_REGEX:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s]).*$/,
  APP_LOGO_LIGHT: `${staticFileBasePath}/images/app-logo-light.svg`,
  APP_LOGO_DARK: `${staticFileBasePath}/images/app-logo-dark.svg`,
  APP_LOGO_ICON: `${staticFileBasePath}/images/app-logo-icon.svg`,
  PROFILE_SELECTION_ILLUSTRATION_LIGHT: `${staticFileBasePath}/images/select-profile-light.svg`,
  PROFILE_SELECTION_ILLUSTRATION_DARK: `${staticFileBasePath}/images/select-profile-dark.svg`,
  LOGO_STORAGE_PATH: `${s3Url}/AllFiles/Uploads/Logos/`,
  CLIENT_APP: '4'
} as const;

export default appConfig;
